const edtDynamicCheckLogEn = {
	edtDynamicCheckLogTable: 'EDT Dynamic Check Log',
	name: 'Name',
	edtDynamicCheckLogEditForm: 'EDT Dynamic Check Log',
	userGroup: 'User Group',
};

export default edtDynamicCheckLogEn;